import { render, staticRenderFns } from "./CreateLayout.vue?vue&type=template&id=6008c615&scoped=true"
import script from "./CreateLayout.vue?vue&type=script&lang=js"
export * from "./CreateLayout.vue?vue&type=script&lang=js"
import style0 from "./CreateLayout.vue?vue&type=style&index=0&id=6008c615&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6008c615",
  null
  
)

export default component.exports